// extracted by mini-css-extract-plugin
export default {"fields":"BulkReachoutTemplateFields_fields__IscwT","field":"BulkReachoutTemplateFields_field__H-yaU","fieldLabel":"BulkReachoutTemplateFields_fieldLabel__uiFqH"};